/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="none" stroke="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M17.5 17.5L13.1692 13.1692M13.1692 13.1692C14.3413 11.997 14.9998 10.4072 14.9998 8.74958C14.9998 7.09192 14.3413 5.50215 13.1692 4.33C11.997 3.15785 10.4072 2.49935 8.74958 2.49935C7.09192 2.49935 5.50215 3.15785 4.33 4.33C3.15785 5.50215 2.49935 7.09192 2.49935 8.74958C2.49935 10.4072 3.15785 11.997 4.33 13.1692C5.50215 14.3413 7.09192 14.9998 8.74958 14.9998C10.4072 14.9998 11.997 14.3413 13.1692 13.1692Z"
            />
        </svg>
    );
}
